import { render, staticRenderFns } from "./BoardViewLog.vue?vue&type=template&id=316461d8&scoped=true"
import script from "./BoardViewLog.ts?vue&type=script&lang=ts&external"
export * from "./BoardViewLog.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardViewLog.vue?vue&type=style&index=0&id=316461d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316461d8",
  null
  
)

export default component.exports